import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadForwardDefaults = (context, documentId) => new Promise((resolve, reject) => {
  Api.documentService.getForwardDefaults(documentId)
    .then(response => {
      context.commit('setForwardDefaults', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setForwardDefaults', []);
      const httpError = Http.createError(
        error,
        'documents.actions.loadForwardDefaults',
        { documentId },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const forwardDocument = (context, forwardData) => new Promise((resolve, reject) => {
  Api.documentService.postForwardDocument(forwardData.id, forwardData)
    .then(response => {
      context.commit('setForwardDefaults', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setForwardDocument', []);
      const httpError = Http.createError(
        error,
        'documents.actions.forwardDocument',
        { forwardData },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

export default {
  loadForwardDefaults,
  forwardDocument,
};
